/*
 * @Author: your name
 * @Date: 2022-03-01 11:06:49
 * @LastEditTime: 2022-03-27 23:40:09
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \tongxing\src\store\modules\app.js
 */
import apiExc from '@/api/api-hub'
const dictCodes = ['member_type', 'feedback_type', 'education_status', 'nature_work', 'marriage_type', 'make_friends_type', 'marriage_status', 'feel_status']
export default {
    state: {
        member_type: [],
        feedback_type: [], // 反馈类型
        education_status: [], // 学历
        nature_work: [], // 工作性质
        marriage_type: [],
        make_friends_type: [], // 交由类型
        marriage_status: [], // 婚史类型
        feel_status: [], // 感情状况
        sex_type: [
            { text: '男', title: '男', value: 0 },
            { text: '女', title: '女', value: 1 },
        ],
        other_type: [
            { text: '未知', title: '未知', value: 0 },
            { text: '是', title: '是', value: 1 },
            { text: '否', title: '否', value: 2 },
        ],
        sex_type_query: [
            { text: '不限', value: ''},
            { text: '男', value: '1'},
            { text: '女', value: '2'},
        ],
        other_type_query: [
            { text: '不限', value: ''},
            { text: '是', value: '1'},
            { text: '否', value: '2'},
        ],
        vip_attributes1: [
            { text: 'T', value: 'T'},
            { text: 'P', value: 'P'},
            { text: 'H', value: 'H'},
        ],
        vip_attributes2: [
            { text: '1', value: '1'},
            { text: '0', value: '0'},
            { text: '0.5', value: '0.5'},
        ],
    },
    mutations: {
        // 设置数据
        SET_DATA(state, payload) {
            if(payload) {
                state.member_type = payload.member_type
                state.feedback_type = payload.feedback_type
                state.education_status = payload.education_status
                state.nature_work = payload.nature_work
                state.marriage_type = payload.marriage_type
                state.make_friends_type = payload.make_friends_type
                state.marriage_status = payload.marriage_status
                state.feel_status = payload.feel_status
            }
        },
    },
    actions: {
        /** 初始化数据 */
        InitData(context) {
            var dictionary = {
                member_type: [],
                feedback_type: [],
                education_status: [],
                nature_work: [],
                marriage_type: [],
                make_friends_type: [],
            }
            var promiseArray = []
            dictCodes.forEach(code=> {
                promiseArray.push(apiExc.dictClient.getDictItemByDictCode(code))
            })
            Promise.all(
                promiseArray.map(promise => promise.then((res) => (res), (err) => ({ err }))
            )).then(res =>
                {
                    res.forEach((data, index)=> {
                        if(data && data.result) {
                            dictionary[dictCodes[index]] = data.result
                        }
                    })
                    context.commit('SET_DATA', dictionary)
                }
                ,err => console.log(err)
            )
        },
    },
    getters: {

    }
};  